// npm
import React from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

// app
import Lang, { GetTranslation } from '../../../components/app/language';

// component
import { Main, Title, Form, Group, Label, Input, Button, Nav, NavButton } from './login';
import API from '../../../components/api';
import Captcha from '../../../components/captcha';

// default
export default ({ changeForm, toggleBusy }) => {
	const lang = useSelector(s => s.lang);

	const formSubmit = e => {
		e.preventDefault();

		toggleBusy(true);

		let form = e.currentTarget;
		let data = new FormData(form);

		API(data, 'recoverUserPass').then(data => {
			if (typeof data.success === 'undefined' || !data.success) {
				toast.error(GetTranslation('home.modal.form.recovery.error', lang));
			} else {
				toast.success(GetTranslation('home.modal.form.recovery.success', lang));

				form.reset();
			}

			toggleBusy(false);
		});
	};

	return (
		<Main>
			<Title>
				<Lang id='home.modal.title.recovery' />
			</Title>

			<Form onSubmit={formSubmit.bind(this)}>
				<Group>
					<Label>
						<Lang id='home.modal.form.email' />
					</Label>
					<Input type='email' name='email' />
				</Group>

				<Group className='recaptcha'>
					<Captcha />
				</Group>

				<Button>
					<Lang id='home.modal.form.recovery.submit' />
				</Button>
			</Form>

			<Nav>
				<NavButton onClick={e => changeForm(e, 'register')}>
					<Lang id='home.modal.title.register' />
				</NavButton>

				<NavButton onClick={e => changeForm(e, 'login')}>
					<Lang id='home.modal.title.login' />
				</NavButton>
			</Nav>
		</Main>
	);
};
